import { useAtomValue } from 'jotai';
import React from 'react';
import { projectsAtom } from '../App';
import ProjectCard from '../components/ProjectCard';
import { Box, Grid, Paper, TextField } from '@mui/material';

const Projects = () => {
    const projects = useAtomValue(projectsAtom);
    const [search, setSearch] = React.useState<string>('');
    const handleSearch = (event: any) => {
        setSearch(event.target.value);
    }

    const searchedProjects = projects && projects.filter((project) => {
        if (project.name.toLowerCase().includes(search) ||
            project.description?.toLowerCase().includes(search)) {
            return true;
        }
        return false;
    }).map((project) => {
        return <ProjectCard project={project} />
    });

    return (
        <React.Fragment>
            <Paper sx={{ padding: '1.5em', marginBottom: '0.75em' }} elevation={0.75}>
                <Grid size={1}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box sx={{ maxWidth: '7500px', marginBottom: '1em' }}>
                            These are my GitHub projects, this page is automatically updated using the GitHub API.
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box sx={{ maxWidth: '500px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <TextField
                                sx={{ width: '90%' }}
                                id='filled-search'
                                label='Search Projects'
                                type='search'
                                variant='outlined'
                                onChange={handleSearch}
                            />
                        </Box>
                    </Box>
                </Grid>
            </Paper>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                {searchedProjects?.length ? searchedProjects : "No projects were found using the given key words"}
            </Box>
        </React.Fragment>
    );
}

export default Projects;
